import React, { useContext } from 'react';

import * as S from './styles';
import { ItemDynamicPageInPhone } from 'types/ItemDynamicPageInPhone';
import { DataFormCarroselBannersProps } from 'types/DataFormCarroselBannersProps';
import ScheduleInfoDynamicPage from 'components/ScheduleInfoDynamicPage';
import WaitingForDataDynamicPage from 'components/WaitingForDataDynamicPage';
import TypeStoreContext from 'context/TypeStoreContext';
import Default from './interfaces/Default';
// import Fashion from './interfaces/Fashion';
// import Grocery from './interfaces/Grocery';

interface CarrosselBannersProps {
	item: ItemDynamicPageInPhone;
}

export default function CarrosselBanners({ item }: CarrosselBannersProps) {
	const { data } = item;
	const { typeStore } = useContext(TypeStoreContext);

	const bannersData: DataFormCarroselBannersProps = data;

	function returnInterfaceByTypeStore() {
		switch (typeStore) {
			case 'default':
				return <Default bannersData={bannersData} />;

			case 'grocery':
				return <Default bannersData={bannersData} />;

			case 'fashion':
				return <Default bannersData={bannersData} />;

			default:
				return <Default bannersData={bannersData} />;
		}
	}

	return Object.keys(item.data).length === 0 ? (
		<WaitingForDataDynamicPage />
	) : (
		<S.container>
			{(bannersData.schedule?.start !== '' ||
				bannersData.schedule.end !== '') && (
				<ScheduleInfoDynamicPage
					countdown={bannersData.schedule?.countdown || false}
					endDate={bannersData.schedule?.end || ''}
					startDate={bannersData.schedule?.start || ''}
				/>
			)}

			{returnInterfaceByTypeStore()}
		</S.container>
	);
}
